const VERSION = "6.1.3";
export {
  VERSION
};
